// TODO: Add sane error message feedback to form elements
// TODO: Add Advanced or Import tab to import event
// TODO: Add prop 'eventData' to be used in case user is copying an event
// This would pre-fill the form defaultValues
// Add Related Tab content after feedback

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EventActions, ImageActions, WorldActions } from "../../_actions";
import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { DevTool } from "@hookform/devtools";
import Select from "react-dropdown-select";
import bigInt from "big-integer";
import ReactTooltip from "react-tooltip";
import { useEventListener } from "../../_hooks";

import { eventSignificanceOptions } from "../../_helpers";
import { useTime, useModal, useApp } from "../../_contexts";
import {
  Button,
  Tabs,
  Icon,
  FileDropzone,
  TagInput,
  LocationMarkerPicker,
  ColorPicker,
  IconTextInput,
  ImagePicker,
  ArticlePicker,
  TagInputOld,
  CalendarDatePicker,
  Toggle,
  SubGroupPicker,
  PaneLoader,
  RelatedArticlePicker,
  FormError,
} from "../../_components";

import {
  EventSignificanceSelect,
  EventTypeSelect,
  TimelineLaneSelect,
  TimelineSelect,
} from "../_components";

const MAX_FILESIZE_MB = 30;

const MAX_TIMELINE_LANES = 4;

const laneOptions = [
  { label: "Lane 1", value: 0 },
  { label: "Lane 2", value: 1 },
  { label: "Lane 3", value: 2 },
  { label: "Lane 4", value: 3 },
];

export function NewEventForm(props) {
  // console.log('EventForm Props', props);
  const { timeline, allowedTypes, item, close, prevModal } = props;
  const [isLoading, setLoading] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);

  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { details: world, subgroups } = useSelector((state) => state.world);
  const { items: timelines } = useSelector((state) => state.timelines);
  const { closeModal, openModal } = useModal();
  const { calendar, currentDate } = useTime();
  const { user } = useApp();
  // console.log("Event Item", item);
  const dispatch = useDispatch();

  const {
    handleSubmit,
    control,
    getValues,
    setError,
    errors,
    watch,
    setValue,
    formState,
    trigger,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      title: item?.title || "",
      description: item?.description || "",
      excerpt: item?.excerpt || "",
      category: item?.category || "",
      significance: item?.significance || null,
      tags: item?.tags || [],
      cover: {
        new: [],
        existing: item
          ? item.cover && typeof item.cover === "string"
            ? item.cover
            : item.cover?._id || ""
          : "",
      },
      fromDate: item?.fromDate || currentDate || "0",
      toDate: item?.toDate || "",
      timeline: item?.timeline || timeline || null,
      chronicle: item?.chronicle || chronicle._id,
      private: item?.private || false,
      subGroups: item?.subGroups || [],
      world: item?.world || (world && world._id) ? world._id : null,
      marker: item?.marker?.id || item?.marker || null,
      color: item?.color || "",
      icon: item?.icon || "",
      lane: item?.lane || 0,
      waID: item?.waID || "",
      linkedArticles: item?.linkedArticles || [],
    },
    shouldUnregister: false,
  });

  const handleSelectExistingImage = (onChange, value) => {
    onChange(value);
    setValue("cover.new", []);
  };

  const handleSelectNewImage = (onChange, value) => {
    onChange(value);
    setValue("image.existing", "");
  };

  // const handleTabChange = (ev) => {
  //   console.warn("--- tab change");
  // };

  const onSubmit = (formData) => {
    // return;
    setLoading(true);
    // console.log('New Event', formData);
    let fromDate = formData.fromDate;
    let toDate =
      formData.toDate && formData.toDate !== null ? formData.toDate : null;

    //Perform Form Validation
    if (toDate && bigInt(toDate).lesser(fromDate)) {
      console.log(
        `[CHRONOS] Error: The "End Date" must be greater than the "Start Date"`
      );
      setError("toDate", {
        type: "manual",
        message: "The End Date must be either blank or after the Start Date.",
      });
      return;
    }

    //Construct the EventObject
    const newEvent = {
      ...formData,
      fromDate: fromDate,
      toDate: toDate,
      lane: formData.lane || 0,
      waID: formData.waID === "" ? null : formData.waID,
    };
    // console.warn('EVENT: ', { ...newEvent });

    if (formData.cover.new && formData.cover.new.length === 1) {
      //We need to upload the image first, then update the Event
      //with the image's ID. First, create Form Data for request
      let newImage = new FormData();
      newImage.append("name", formData.title);
      newImage.append("imageType", "cover");
      newImage.append("world", world._id);
      newImage.append("chronicle", chronicle._id);
      newImage.append("waUser", user.userID);
      //If the image has a preview property, we need to remove it to
      //prevent the data from the image being uploaded twice. Not a
      //huge issue, just done to conserve bandwidth and make the upload
      //faster.
      if (formData.cover.new[0].preview) {
        delete formData.cover.new[0].preview;
      }
      //Append the image file to the FormData
      newImage.append("images", formData.cover.new[0]);

      //Upload the Image
      dispatch(ImageActions.upload(newImage)).then((results) => {
        //Successfully uploaded image. Now, set the Event's
        //cover property to the ID of the Image.
        newEvent.cover = results[0]._id;

        //Next, we'll check if we're updating an existing Event or
        //creating a new one
        if (item && item._id) {
          //Updating an existing Event
          dispatch(EventActions.updateEvent(item._id, newEvent))
            .then(() => {
              setLoading(false);
              // closeModal();
              handleCancel();
            })
            .catch((err) => {
              // console.log('Error updating event', err);
              console.error("Image Upload Failure: ", err);
              // toast.error('Unable to upload the new Image. Please try again in a moment.')
            });
        } else {
          //Creating a new Event
          dispatch(EventActions.saveNewEvent(newEvent))
            .then((response) => {
              setLoading(false);
              // console.log(response);
              //Toast Success
              //Close Modal
              // closeModal();
              handleCancel();
            })
            .catch((err) => {
              console.log("Event creation error: ", err);

              //Toast Error
              //keep the modal open though.
            });
        }
      });
    } else {
      //We're not uploading a new Image, so we can safely proceed.
      //Simply swap the Image ID on the Event
      newEvent.cover = formData.cover.existing;

      //We need to determine if we're updating an existing Event or
      //creating a new one.
      if (item && item._id) {
        //Updating an existing Event
        dispatch(EventActions.updateEvent(item._id, newEvent))
          .then(() => {
            setLoading(false);
            // closeModal();
            handleCancel();
          })
          .catch((err) => {
            console.error("Error updating event", err);
          });
      } else {
        //Creating a new Event
        dispatch(EventActions.saveNewEvent(newEvent))
          .then((response) => {
            //Toast Success
            //Close Modal
            setLoading(false);
            // closeModal();
            handleCancel();
            // console.log(response);
          })
          .catch((err) => {
            console.error("EVENT error:", err);
            //Toast Error
            //keep the modal open though.
          });
      }
    }

    //Dispatch to server
    // console.log('Event Data', newEvent);
  };

  const handleCancel = (ev) => {
    setLoading(false);
    if (close) {
      if (prevModal && prevModal.length > 0 && prevModal !== "newEvent") {
        openModal(prevModal);
      } else {
        close();
      }
    }
  };

  const handleDelete = (ev) => {
    ev.preventDefault();
    openModal("confirmDelete", { type: "event", item });
  };

  useEffect(() => {
    if (world && world.waID) {
      dispatch(WorldActions.getSubGroups(world.waID));
    }
  }, []);

  const {
    isValidating,
    isSubmitting,
    dirtyFields,
    touched,
    errors: formErrors,
  } = formState;

  const handleKeyClose = (ev) => {
    // console.log("Key up: ", ev);
    if (ev.key && ev.key.toLowerCase() === "escape") {
      console.log("Form State: ", { ...formState });
      if (!isValidating && !isSubmitting) {
        if (
          // formState.dirtyFields &&
          Object.keys(dirtyFields).length === 0 &&
          // formState.touched &&
          Object.keys(touched).length === 0
        ) {
          // console.log("dirty fields!");
          handleCancel();
        }
      }
    }
  };

  useEventListener("keyup", handleKeyClose);

  const defaultImageTab = item
    ? item.cover && typeof item.cover === "string"
      ? 1
      : 0
    : 0;

  const tooltipID = "chronosEventForm";
  const tooltipIcon = "fas fa-question-circle fa-fw";
  // console.log('DisplayTab ImageTab:', defaultImageTab);
  // console.log("Current Date: ", currentDate, item);
  // console.log("Form Errors:", formErrors);

  const handleTabChange = () => {
    ReactTooltip.rebuild();
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="chronos-form">
      <Tabs
        tabs={["General", "Display", "Privacy", "Links"]}
        onTabChange={handleTabChange}
      >
        <div>
          <div className="form-group">
            <label htmlFor="title" className="chronos-form-title">
              Title<sup className="required-flag">*</sup>
            </label>
            <Controller
              control={control}
              name="title"
              id="title"
              as="input"
              // render={({ value, onChange }) => (
              //   <input
              //     name="title"
              //     id="title"
              //     className="form-control"
              //     autoComplete="off"
              //     value={value}
              //     onChange={onChange}
              //   />
              // )}
              autoComplete="off"
              className="form-control"
              rules={{
                required: {
                  value: true,
                  message: "You need to give the Event a name.",
                },
                minLength: {
                  value: 3,
                  message:
                    "The Event name must be at least 3 characters in length.",
                },
              }}
            />
            <ErrorMessage
              errors={errors}
              name="title"
              render={({ message }) => <FormError message={message} />}
            />
          </div>
          <div className="form-group">
            <label htmlFor="excerpt" className="chronos-form-title">
              Excerpt&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="The Excerpt is displayed when a visitor clicks this Event in the Timeline."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="excerpt"
              id="excerpt"
              as="textarea"
              className="form-control"
              autoComplete="off"
              style={{ height: "4em" }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="description" className="chronos-form-title">
              Long Description
              <sup className="required-flag">*</sup>
            </label>
            <Controller
              control={control}
              name="description"
              id="description"
              as="textarea"
              className="form-control"
              autoComplete="off"
              style={{ height: "10em" }}
              rules={{
                required: {
                  value: true,
                  message: "You must include a description for this Event.",
                },
              }}
            />
            <ErrorMessage
              errors={errors}
              name="description"
              render={({ message }) => <FormError message={message} />}
            />
          </div>
          <div className="chronos-form-section-horizontal">
            <div className="form-group">
              <label htmlFor="fromDate" className="chronos-form-title">
                Start
                <sup className="required-flag">*</sup>
                &nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This is the date the Event occurs or starts."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="fromDate"
                id="fromDate"
                render={({ onChange, value }) => (
                  <CalendarDatePicker
                    calendar={calendar}
                    onChange={onChange}
                    placeholder="Start Date"
                    isDirty={formState.dirtyFields["fromDate"] !== value}
                    tooltipID={tooltipID}
                    value={value}
                    align="left"
                  />
                )}
                rules={{
                  required: {
                    value: true,
                    message: "You must specify a Date/Time for this Event.",
                  },
                }}
              />
              <ErrorMessage
                errors={errors}
                name="fromDate"
                render={({ message }) => <FormError message={message} />}
              />
            </div>

            <div className="form-group">
              <label htmlFor="toDate" className="chronos-form-title">
                End &nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This is the date the Event ends. Leave blank to display the Event as an icon on the Timeline."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="toDate"
                id="toDate"
                render={({ onChange, value }) => (
                  <CalendarDatePicker
                    calendar={calendar}
                    onChange={onChange}
                    value={value}
                    placeholder="Select Date"
                    // defaultStart={watch('fromDate')}
                    defaultStartDate={watch("fromDate")}
                    defaultNull
                    isDirty={formState.dirtyFields["toDate"]}
                    tooltipID={tooltipID}
                    clearable
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="toDate"
                render={({ message }) => <FormError message={message} />}
              />
            </div>
          </div>

          <div className="chronos-form-section-horizontal">
            <div className="form-group">
              <label htmlFor="category" className="chronos-form-title">
                Event Type&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="The Event Type determines the large icon that's shown when a visitor clicks on this Event."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="category"
                render={({ onChange, value }) => {
                  return (
                    <EventTypeSelect
                      options={allowedTypes}
                      value={value}
                      onChange={onChange}
                      clearable
                    />
                  );
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="significance" className="chronos-form-title">
                Significance&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This denotes how important or how much of an impact this event has had. This also gives the Event a different shape on the Timeline."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="significance"
                // id="significance"
                autoComplete="off"
                className="form-control"
                render={({ onChange, value }) => {
                  const handleSelectChange = (values) => {
                    const selectedVal = values[0];
                    const newVal = selectedVal ? selectedVal.value : null;
                    onChange(newVal);
                  };

                  const defVal = eventSignificanceOptions.find(
                    (o) => o.value === value
                  ) || { value: "00000", name: "Select One" };
                  return (
                    <EventSignificanceSelect
                      options={eventSignificanceOptions}
                      value={value}
                      onChange={onChange}
                      clearable
                    />
                    // <Select
                    //   options={eventSignificanceOptions}
                    //   onChange={handleSelectChange}
                    //   values={[defVal]}
                    //   id="significance"
                    //   valueField="value"
                    //   labelField="name"
                    //   searchField="name"
                    //   searchBy="name"
                    //   className="form-control chronos-select"
                    //   dropdownGap={0}
                    //   optionRenderer={({ item, props, state, methods }) => {
                    //     return (
                    //       <span
                    //         className="chronos-select-chosen-item"
                    //         key={item._id}
                    //       >

                    //         {item.name}
                    //       </span>
                    //     );
                    //   }}
                    //   itemRenderer={({
                    //     item,
                    //     itemIndex,
                    //     // props,
                    //     // state,
                    //     methods,
                    //   }) => {
                    //     return (
                    //       <div
                    //         className="chronos-select-dropdown-item"
                    //         onClick={() => methods.addItem(item)}
                    //         key={itemIndex}
                    //       >

                    //         {item.name}
                    //       </div>
                    //     );
                    //   }}
                    //   contentRenderer={({ state }) => {
                    //     const item = state.values[0] || null;
                    //     return (
                    //       <div className="chronos-select-chosen-option">
                    //         {item && (
                    //           <>

                    //             {item.name}
                    //           </>
                    //         )}
                    //       </div>
                    //     );
                    //   }}
                    // />
                  );
                }}
              />
            </div>
          </div>

          <div className="chronos-form-section-horizontal">
            <div className="form-group">
              <label htmlFor="timeline" className="chronos-form-title">
                Timeline&nbsp;
                <sup className="required-flag">*</sup>
                <Icon
                  icon={tooltipIcon}
                  data-tip="Select the Timeline you'd like to display this Event on."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="timeline"
                id="timeline"
                render={({ value, onChange }) => {
                  const handleSelectChange = (values) => {
                    // console.log('New Value ', values[0])
                    const selectedVal = values[0];
                    const newVal = selectedVal ? selectedVal._id : null;
                    onChange(newVal);
                  };
                  const defVal = timelines.find((t) => t._id === value) || {
                    _id: null,
                    title: "None",
                  };
                  return (
                    <TimelineSelect
                      options={timelines || []}
                      value={value}
                      onChange={onChange}
                    />
                    // <Select
                    //   options={timelines || []}
                    //   values={[defVal]}
                    //   onChange={handleSelectChange}
                    //   labelField="title"
                    //   valueField="_id"
                    //   className="chronos-select"
                    //   dropdownGap={0}
                    // />
                  );
                }}
                rules={{
                  required: {
                    value: true,
                    message: "You must select a valid Timeline for this Event.",
                  },
                  validate: (value) =>
                    (value &&
                      value !== null &&
                      value !== "" &&
                      value !== "00000") ||
                    "You must select a valid Timeline for this Event.",
                }}
              />
              <ErrorMessage
                errors={errors}
                name="timeline"
                render={({ message }) => <FormError message={message} />}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lane" className="chronos-form-title">
                Timeline Lane&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This helps organize the Timeline by placing Events in different horizontal lanes."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="lane"
                id="lane"
                render={({ value, onChange }) => {
                  const handleSelectChange = (values) => {
                    const selectedVal = values[0];
                    const newVal = selectedVal ? selectedVal.value : 0;
                    onChange(newVal);
                  };
                  const defVal = laneOptions.find((o) => o.value === value) || {
                    label: "Lane 1",
                    value: 0,
                  };
                  return (
                    <TimelineLaneSelect
                      options={laneOptions}
                      value={value}
                      onChange={onChange}
                    />
                    // <Select
                    //   options={laneOptions}
                    //   values={[defVal]}
                    //   onChange={handleSelectChange}
                    //   labelField="label"
                    //   valueField="value"
                    //   className="chronos-select"
                    //   dropdownGap={0}
                    // />
                  );
                }}
                rules={{
                  required: {
                    value: true,
                    message: "You must select a Timeline Lane for this Event.",
                  },
                  min: {
                    value: 0,
                    message: "You must select a valid Timeline Lane.",
                  },
                  max: {
                    value: MAX_TIMELINE_LANES - 1,
                    message: "You must select a valid Timeline Lane.",
                  },
                }}
              />
              <ErrorMessage
                errors={errors}
                name="lane"
                render={({ message }) => <FormError message={message} />}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="marker" className="chronos-form-title">
              Map Marker&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="Connect a Map Marker to this Event. This will pan the Map to the coordinates of the Marker when a visitor clicks on the Event."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="marker"
              id="marker"
              render={({ value, onChange }) => (
                <LocationMarkerPicker value={value} onChange={onChange} />
              )}
            />
          </div>
          <div className="form-group">
            <label htmlFor="tags" className="chronos-form-title">
              Tags&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="Tags help organize and make searching for this Event easier for both you and your visitors."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="tags"
              id="tags"
              autoComplete="off"
              className="form-control"
              render={({ onChange, value }) => {
                return (
                  <TagInput
                    value={value}
                    onlyUnique={true}
                    onChange={(e) => onChange(e)}
                    separateEntry
                  />
                );
              }}
            />
          </div>
        </div>
        <div>
          <label htmlFor="cover" className="chronos-form-title">
            Cover Image
          </label>
          <Tabs tabs={["New", "Existing"]} defaultTab={defaultImageTab}>
            <div className="form-group">
              {/* Select New Image */}

              <Controller
                control={control}
                name="cover.new"
                id="cover.new"
                render={({ onChange, value }) => (
                  <FileDropzone
                    onChange={(val) => handleSelectNewImage(onChange, val)}
                    value={value}
                    uploadMb={MAX_FILESIZE_MB}
                    className="chronos-file-dropzone"
                  />
                )}
              />
            </div>
            <div className="form-group">
              {/* Select Existing Image */}
              <Controller
                control={control}
                name="cover.existing"
                render={({ onChange, value }) => (
                  <ImagePicker
                    value={value}
                    onChange={(val) => handleSelectExistingImage(onChange, val)}
                    filters={["cover"]}
                  />
                )}
              />
            </div>
          </Tabs>

          <div className="form-group">
            <label htmlFor="color" className="chronos-form-title">
              Timeline Display Color&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="This adjusts the Event's color on the Timeline."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="color"
              id="color"
              render={({ value, onChange }) => (
                <ColorPicker
                  value={value}
                  onChange={onChange}
                  colorMode="rgba"
                />
              )}
            />
          </div>

          <div className="form-group">
            <label htmlFor="icon" className="chronos-form-title">
              Timeline Display Icon&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="This lets you change the icon shown on the Timeline for this Event."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="icon"
              id="icon"
              render={({ value, onChange }) => (
                <IconTextInput value={value} onChange={onChange} />
              )}
            />
          </div>
        </div>
        <div className="chronos-tab-pane">
          <div className="form-group">
            <label htmlFor="private" className="chronos-form-title">
              Privacy&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="Make the Event private. Only Subscriber Groups you choose will have access to see this Event."
                data-for={tooltipID}
              />
            </label>
            <br />
            <Controller
              control={control}
              name="private"
              // id="private"
              autoComplete="off"
              defaultValue={false}
              render={({ onChange, value }) => {
                return (
                  <Toggle
                    id="private"
                    name="private"
                    checked={value}
                    onChange={onChange}
                    onText="Private"
                    offText="Public"
                    onColor="#dc3545"
                    offColor="#007bff"
                  />
                );
              }}
            />
          </div>
          {watch("private") === true && (
            <div className="form-group">
              <label htmlFor="subGroups" className="chronos-form-title">
                Subscriber Groups&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="Choose the Subscriber Groups that will have access to this Event. They'll appear on the right column."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="subGroups"
                render={({ onChange, value }) => (
                  <SubGroupPicker value={value} onChange={onChange} />
                )}
              />
            </div>
          )}
        </div>
        <div>
          <div className="form-group">
            <label htmlFor="linkedArticles" className="chronos-form-title">
              Linked Articles
            </label>
            <Controller
              control={control}
              id="linkedArticles"
              name="linkedArticles"
              render={({ value, onChange }) => {
                return (
                  <RelatedArticlePicker value={value} onChange={onChange} />
                );
              }}
            />
            {/* <Controller
              control={control}
              id="waID"
              name="waID"
              render={({ value, onChange }) => {
                return <ArticlePicker value={value} onChange={onChange} />;
              }}
            /> */}
          </div>
        </div>
      </Tabs>

      <div className="form-controls">
        {/* {(!item || !item._id) && (
          <Button type="button" color="secondary" onClick={handleCancel}>
            <Icon icon="fas fa-ban fa-fw" />
            &nbsp;Cancel
          </Button>
        )} */}

        {item && item._id ? (
          <Button color="danger" link type="button" onClick={handleDelete}>
            <Icon icon="fas fa-trash fa-fw" />
            &nbsp;Delete Event
          </Button>
        ) : (
          <React.Fragment>&nbsp;</React.Fragment>
        )}
        <Button color="primary" type="submit">
          {(!item || !item._id) && (
            <React.Fragment>
              <Icon icon="fas fa-plus fa-fw" />
              &nbsp;Create Event
            </React.Fragment>
          )}
          {item && item._id && (
            <React.Fragment>
              <Icon icon="fas fa-save fa-fw" />
              &nbsp;Update Event
            </React.Fragment>
          )}
        </Button>
      </div>
      <PaneLoader
        isLoading={isLoading}
        isNew={!(item && item._id)}
        text="Event"
      />
      <ReactTooltip effect="solid" id={tooltipID} />
      <DevTool control={control} />
    </form>
  );
}
